export const TESTING_TYPE = {
  MANUAL: 'MANUAL_TESTING',
  LOAD: 'LOAD_TESTING',
};

export const normalizeTestingType = (value) => (
  value === TESTING_TYPE.LOAD ? TESTING_TYPE.LOAD : TESTING_TYPE.MANUAL
);

export const isLoadTestingType = (value) => normalizeTestingType(value) === TESTING_TYPE.LOAD;

export const isLoadTestingProject = (project) => isLoadTestingType(project?.testingType);

export const testingTypeLabel = (value) => (
  isLoadTestingType(value) ? 'Нагрузочное тестирование' : 'Ручное тестирование'
);
